import React, {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import logotexto from './../assets/images/logotipo.jpg'
import ValidarCorreoElectronico from '../functions/ValidarCorreoElectronico';
import ValidarUsuario from '../functions/ValidarUsuario';
import ActualizarClave from '../functions/ActualizarClave';

// Store de admin
import adminStore from '../store/admin';

// para manipular las rutas con wouter
import { navigate } from "wouter/use-browser-location";
import { useLocation } from 'wouter';

function CambiarClave() {
  
    // Variables del store de admin
    const {usuarioEmail, setUsuarioEmail} = adminStore();
    const {usuarioNombre, setUsuarioNombre} = adminStore();
    const {usuarioApellido, setUsuarioApellido} = adminStore();
    const {usuarioNivel, setUsuarioNivel} = adminStore();
    const {usuarioId, setUsuarioId} = adminStore();
    const {usuarioCelular, setUsuarioCelular} = adminStore();
    
    // Variables de estado locales
    const [error, setError] = useState(false);
    const [errorMensaje, setErrorMensaje] = useState('');
    const [valorEmail, setValorEmail] = useState('');
    const [valorClave, setValorClave] = useState('');
    const [valorClaveNueva, setValorClaveNueva] = useState('');
    const [valorClaveRepetir, setValorClaveRepetir] = useState('');
    const [emailHabilitado, setEmailHabilitado] = useState(true);

    // Hook de navegación
    const [location] = useLocation();
    const fromLogin = location.includes('/login');
    const fromAdmin = location.includes('/admin');

    const cancelarCambioClave = () => {
        navigate('/admin');
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();

        const data = new FormData(event.currentTarget);
        const email = data.get('email') || usuarioEmail;
        const password = data.get('password') || '';
        const claveNueva = data.get('claveNueva') || '';
        const claveRepetir = data.get('claveRepetir') || '';

        if (claveNueva !== claveRepetir) {
            setError(true);
            setErrorMensaje('Las claves nuevas no coinciden');
            return;
        } else {
            setError(false);
            setErrorMensaje('');
        }

        if (ValidarCorreoElectronico(email as string)) {
            if (password && typeof password === 'string' && password.trim().length > 0) {
                if (valorClaveNueva.trim().length >= 8 && valorClaveRepetir.trim().length >= 8) {

                    // La clave actual es correcta
                    // Ahora debo cambiar la clave
                    const respuesta = await ActualizarClave(email as string, password, valorClaveNueva);
                    
                    if (respuesta.clave_actualizada === 'si') {
                    
                        // Limpio los errores
                        setError(false);
                        setErrorMensaje('');

                        // Guardar los datos del usuario en el store
                        setUsuarioEmail(respuesta.usuario.user_email);
                        setUsuarioNombre(respuesta.usuario.user_forename);
                        setUsuarioApellido(respuesta.usuario.user_surname);
                        setUsuarioNivel(respuesta.usuario.user_level);
                        setUsuarioId(respuesta.usuario.user_id);
                        setUsuarioCelular(respuesta.usuario.user_celular);
                        
                        navigate('/admin');
                    } else {
                        console.log("Error al cambiar la clave");
                        setError(true);
                        setErrorMensaje('Error al cambiar la clave.');
                    }

                } else {
                    setError(true);
                    setErrorMensaje('La clave nueva debe tener al menos 8 caracteres');
                }

            } else {
                setError(true);
                setErrorMensaje('Debe ingresar la clave actual');
            }
        } else {
            setError(true);
            setErrorMensaje('El correo electrónico no es válido');
        }
    };

    useEffect(() => {
        if (usuarioEmail === '') {
            setEmailHabilitado(true);
        } else {
            setEmailHabilitado(false);
            setValorEmail(usuarioEmail);
        }
    }, []);


    return (
        <div className='container-fluid flex flex-col items-center justify-center h-dvh'>
            <div className="flex flex-col justify-center items-center bg-white border-2 rounded-lg border-vp-plan-5 shadow-xl shadow-vp-gris xxs:mx-6 xs:mx-6 min-w-[280px]">
                <div className="flex flex-col justify-center items-center p-6 xxs:p-3 xs:p-3 sm:p-3 max-w-sm">
                    <img src={logotexto} className="w-[200px]" alt="VidaPlus Logo" />
                    <h3 className="font-myriad-pro font-regular text-lg mt-4">
                        Área de Administración - Cambiar Clave
                    </h3>
                    <form onSubmit={handleSubmit} noValidate>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            autoComplete="email"
                            type="email"
                            value={valorEmail}
                            onChange={(e) => setValorEmail(e.target.value)}
                            autoFocus={usuarioEmail.trim().length === 0}
                            disabled={usuarioEmail.trim().length > 0}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Clave actual"
                            type="password"
                            id="password"
                            value={valorClave}
                            onChange={(e) => setValorClave(e.target.value)}
                            autoComplete="current-password"
                            autoFocus={usuarioEmail.trim().length > 0}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="claveNueva"
                            label="Nueva clave"
                            type="password"
                            id="claveNueva"
                            value={valorClaveNueva}
                            onChange={(e) => setValorClaveNueva(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="claveRepetir"
                            label="Repetir clave nueva"
                            type="password"
                            id="claveRepetir"
                            value={valorClaveRepetir}
                            onChange={(e) => setValorClaveRepetir(e.target.value)}
                        />
                        {error && (<div className="flex flex-col justify-center items-center mt-2">
                            <h3 className="font-metropolis font-regular text-sm text-red-900">{errorMensaje}</h3>
                        </div>)}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 2, mb: 1 }}
                            disabled={valorClaveNueva !== valorClaveRepetir || valorClaveNueva.trim().length === 0 || valorClaveRepetir.trim().length === 0 || valorClave.trim().length < 8 || valorClaveNueva.trim().length < 8}
                        >
                        Cambiar Clave
                        </Button>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1, mb: 2, backgroundColor: '#f44336', color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#ff7961', // Cambia el color de fondo al pasar el mouse
                                    color: '#ffffff', // Opcional: Cambia el color del texto al pasar el mouse
                                },
                            }}
                            onClick={cancelarCambioClave}
                        >
                        Cancelar
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CambiarClave;